// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.footer {
  background: linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%);
  border-top: 1px solid #dee2e6;
  margin-top: 4rem;
  position: relative;
  overflow: hidden;
}

.footer::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  height: 3px;
  background: linear-gradient(90deg, #8B4513, #D2691E, #8B4513);
}

.footer-container {
  max-width: 1400px;
  margin: 0 auto;
  padding: 0 2rem;
  position: relative;
  z-index: 1;
}

.footer-content {
  display: grid;
  grid-template-columns: 2fr 1fr 1fr 1fr;
  gap: 3rem;
  padding: 3rem 0 2rem 0;
}

.footer-section {
  display: flex;
  flex-direction: column;
  gap: 1rem;
}

.footer-title {
  font-size: 1.8rem;
  font-weight: 700;
  color: #2c3e50;
  margin: 0;
  background: linear-gradient(135deg, #8B4513, #D2691E);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
}

.footer-subtitle {
  font-size: 1.1rem;
  color: #6c757d;
  margin: 0;
  font-weight: 600;
}

.footer-description {
  font-size: 0.95rem;
  color: #495057;
  line-height: 1.6;
  margin: 0;
}

.footer-section-title {
  font-size: 1.2rem;
  font-weight: 600;
  color: #2c3e50;
  margin: 0 0 1rem 0;
  position: relative;
}

.footer-section-title::after {
  content: '';
  position: absolute;
  bottom: -5px;
  left: 0;
  width: 30px;
  height: 2px;
  background: linear-gradient(90deg, #8B4513, #D2691E);
  border-radius: 1px;
}

.footer-links {
  list-style: none;
  padding: 0;
  margin: 0;
  display: flex;
  flex-direction: column;
  gap: 0.8rem;
}

.footer-link {
  color: #6c757d;
  text-decoration: none;
  font-size: 0.95rem;
  transition: all 0.3s ease;
  cursor: pointer;
  background: none;
  border: none;
  padding: 0.5rem 0;
  text-align: left;
  width: 100%;
  position: relative;
  font-weight: 500;
}

.footer-link:hover {
  color: #8B4513;
  transform: translateX(8px);
}

.footer-link::before {
  content: '';
  position: absolute;
  left: -15px;
  top: 50%;
  transform: translateY(-50%);
  width: 0;
  height: 2px;
  background: linear-gradient(90deg, #8B4513, #D2691E);
  transition: width 0.3s ease;
}

.footer-link:hover::before {
  width: 10px;
}

.footer-tech {
  display: flex;
  flex-wrap: wrap;
  gap: 0.6rem;
}

.tech-tag {
  background: linear-gradient(135deg, #8B4513, #D2691E);
  color: white;
  padding: 0.4rem 1rem;
  border-radius: 20px;
  font-size: 0.85rem;
  font-weight: 600;
  border: none;
  transition: all 0.3s ease;
  box-shadow: 0 2px 8px rgba(139, 69, 19, 0.2);
}

.tech-tag:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(139, 69, 19, 0.3);
}

.footer-contact {
  display: flex;
  flex-direction: column;
  gap: 1rem;
}

.contact-item {
  display: flex;
  align-items: center;
  gap: 1rem;
  cursor: pointer;
  padding: 0.8rem;
  border-radius: 12px;
  transition: all 0.3s ease;
  background: rgba(255, 255, 255, 0.5);
  border: 1px solid rgba(139, 69, 19, 0.1);
}

.contact-item:hover {
  background: rgba(139, 69, 19, 0.05);
  transform: translateX(5px);
  border-color: rgba(139, 69, 19, 0.2);
}

.contact-icon {
  font-size: 1.3rem;
  min-width: 1.8rem;
  display: flex;
  align-items: center;
  justify-content: center;
}

.contact-text {
  color: #495057;
  font-size: 0.95rem;
  font-weight: 500;
  transition: color 0.3s ease;
}

.contact-item:hover .contact-text {
  color: #8B4513;
}

.footer-bottom {
  border-top: 1px solid #dee2e6;
  padding: 2rem 0;
  background: rgba(255, 255, 255, 0.3);
}

.footer-bottom-content {
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-wrap: wrap;
  gap: 1.5rem;
}

.footer-copyright {
  color: #6c757d;
  font-size: 0.9rem;
  margin: 0;
  font-weight: 500;
}

.footer-social {
  display: flex;
  gap: 1rem;
}

.social-btn {
  width: 45px;
  height: 45px;
  border: none;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: all 0.3s ease;
  background: white;
  border: 2px solid #e9ecef;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
}

.social-btn:hover {
  transform: translateY(-3px);
  box-shadow: 0 6px 20px rgba(0, 0, 0, 0.15);
}

.github-btn {
  color: #6c757d;
}

.github-btn:hover {
  background: #333;
  color: white;
  border-color: #333;
}

.linkedin-btn {
  color: #6c757d;
}

.linkedin-btn:hover {
  background: #0077b5;
  color: white;
  border-color: #0077b5;
}

.email-btn {
  color: #6c757d;
}

.email-btn:hover {
  background: #ea4335;
  color: white;
  border-color: #ea4335;
}

/* Dark theme support */
[data-theme="dark"] .footer {
  background: linear-gradient(135deg, #1a1a1a 0%, #2d2d2d 100%);
  border-color: #404040;
}

[data-theme="dark"] .footer::before {
  background: linear-gradient(90deg, #D2691E, #CD853F, #D2691E);
}

[data-theme="dark"] .footer-title {
  background: linear-gradient(135deg, #D2691E, #CD853F);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
}

[data-theme="dark"] .footer-subtitle {
  color: #b0b0b0;
}

[data-theme="dark"] .footer-description {
  color: #d0d0d0;
}

[data-theme="dark"] .footer-section-title {
  color: #f0f0f0;
}

[data-theme="dark"] .footer-section-title::after {
  background: linear-gradient(90deg, #D2691E, #CD853F);
}

[data-theme="dark"] .footer-link {
  color: #b0b0b0;
}

[data-theme="dark"] .footer-link:hover {
  color: #D2691E;
}

[data-theme="dark"] .footer-link::before {
  background: linear-gradient(90deg, #D2691E, #CD853F);
}

[data-theme="dark"] .tech-tag {
  background: linear-gradient(135deg, #D2691E, #CD853F);
  box-shadow: 0 2px 8px rgba(210, 105, 30, 0.3);
}

[data-theme="dark"] .tech-tag:hover {
  box-shadow: 0 4px 12px rgba(210, 105, 30, 0.4);
}

[data-theme="dark"] .contact-item {
  background: rgba(255, 255, 255, 0.05);
  border-color: rgba(210, 105, 30, 0.2);
}

[data-theme="dark"] .contact-item:hover {
  background: rgba(210, 105, 30, 0.1);
  border-color: rgba(210, 105, 30, 0.3);
}

[data-theme="dark"] .contact-text {
  color: #d0d0d0;
}

[data-theme="dark"] .contact-item:hover .contact-text {
  color: #D2691E;
}

[data-theme="dark"] .footer-bottom {
  background: rgba(0, 0, 0, 0.2);
  border-color: #404040;
}

[data-theme="dark"] .footer-copyright {
  color: #b0b0b0;
}

[data-theme="dark"] .social-btn {
  background: #2d2d2d;
  border-color: #404040;
  color: #b0b0b0;
}

[data-theme="dark"] .social-btn:hover {
  box-shadow: 0 6px 20px rgba(0, 0, 0, 0.3);
}

/* Responsive Design */
@media (max-width: 1200px) {
  .footer-container {
    padding: 0 1.5rem;
  }
  
  .footer-content {
    gap: 2.5rem;
  }
}

@media (max-width: 768px) {
  .footer-content {
    grid-template-columns: 1fr;
    gap: 2rem;
    padding: 2rem 0 1.5rem 0;
  }
  
  .footer-container {
    padding: 0 1rem;
  }
  
  .footer-bottom-content {
    flex-direction: column;
    text-align: center;
    gap: 1.5rem;
  }
  
  .footer-social {
    justify-content: center;
  }
  
  .footer-title {
    font-size: 1.6rem;
  }
}

@media (max-width: 480px) {
  .footer-container {
    padding: 0 0.5rem;
  }
  
  .footer-content {
    padding: 1.5rem 0 1rem 0;
  }
  
  .footer-title {
    font-size: 1.4rem;
  }
  
  .footer-description {
    font-size: 0.9rem;
  }
  
  .tech-tag {
    font-size: 0.8rem;
    padding: 0.3rem 0.8rem;
  }
  
  .social-btn {
    width: 40px;
    height: 40px;
  }
  
  .contact-item {
    padding: 0.6rem;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/Footer/Footer.css"],"names":[],"mappings":"AAAA;EACE,6DAA6D;EAC7D,6BAA6B;EAC7B,gBAAgB;EAChB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,QAAQ;EACR,WAAW;EACX,6DAA6D;AAC/D;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,eAAe;EACf,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,sCAAsC;EACtC,SAAS;EACT,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,SAAS;EACT,qDAAqD;EACrD,6BAA6B;EAC7B,oCAAoC;EACpC,qBAAqB;AACvB;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,gBAAgB;EAChB,SAAS;AACX;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,YAAY;EACZ,OAAO;EACP,WAAW;EACX,WAAW;EACX,oDAAoD;EACpD,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,UAAU;EACV,SAAS;EACT,aAAa;EACb,sBAAsB;EACtB,WAAW;AACb;;AAEA;EACE,cAAc;EACd,qBAAqB;EACrB,kBAAkB;EAClB,yBAAyB;EACzB,eAAe;EACf,gBAAgB;EAChB,YAAY;EACZ,iBAAiB;EACjB,gBAAgB;EAChB,WAAW;EACX,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,0BAA0B;AAC5B;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,WAAW;EACX,QAAQ;EACR,2BAA2B;EAC3B,QAAQ;EACR,WAAW;EACX,oDAAoD;EACpD,2BAA2B;AAC7B;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,aAAa;EACb,eAAe;EACf,WAAW;AACb;;AAEA;EACE,qDAAqD;EACrD,YAAY;EACZ,oBAAoB;EACpB,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;EAChB,YAAY;EACZ,yBAAyB;EACzB,4CAA4C;AAC9C;;AAEA;EACE,2BAA2B;EAC3B,6CAA6C;AAC/C;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,eAAe;EACf,eAAe;EACf,mBAAmB;EACnB,yBAAyB;EACzB,oCAAoC;EACpC,wCAAwC;AAC1C;;AAEA;EACE,mCAAmC;EACnC,0BAA0B;EAC1B,oCAAoC;AACtC;;AAEA;EACE,iBAAiB;EACjB,iBAAiB;EACjB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,2BAA2B;AAC7B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,6BAA6B;EAC7B,eAAe;EACf,oCAAoC;AACtC;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,eAAe;EACf,WAAW;AACb;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,SAAS;AACX;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,yBAAyB;EACzB,iBAAiB;EACjB,yBAAyB;EACzB,wCAAwC;AAC1C;;AAEA;EACE,2BAA2B;EAC3B,0CAA0C;AAC5C;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,qBAAqB;AACvB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,qBAAqB;AACvB;;AAEA,uBAAuB;AACvB;EACE,6DAA6D;EAC7D,qBAAqB;AACvB;;AAEA;EACE,6DAA6D;AAC/D;;AAEA;EACE,qDAAqD;EACrD,6BAA6B;EAC7B,oCAAoC;EACpC,qBAAqB;AACvB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,oDAAoD;AACtD;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,oDAAoD;AACtD;;AAEA;EACE,qDAAqD;EACrD,6CAA6C;AAC/C;;AAEA;EACE,8CAA8C;AAChD;;AAEA;EACE,qCAAqC;EACrC,qCAAqC;AACvC;;AAEA;EACE,mCAAmC;EACnC,qCAAqC;AACvC;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,8BAA8B;EAC9B,qBAAqB;AACvB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,yCAAyC;AAC3C;;AAEA,sBAAsB;AACtB;EACE;IACE,iBAAiB;EACnB;;EAEA;IACE,WAAW;EACb;AACF;;AAEA;EACE;IACE,0BAA0B;IAC1B,SAAS;IACT,wBAAwB;EAC1B;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,sBAAsB;IACtB,kBAAkB;IAClB,WAAW;EACb;;EAEA;IACE,uBAAuB;EACzB;;EAEA;IACE,iBAAiB;EACnB;AACF;;AAEA;EACE;IACE,iBAAiB;EACnB;;EAEA;IACE,wBAAwB;EAC1B;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,iBAAiB;IACjB,sBAAsB;EACxB;;EAEA;IACE,WAAW;IACX,YAAY;EACd;;EAEA;IACE,eAAe;EACjB;AACF","sourcesContent":[".footer {\n  background: linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%);\n  border-top: 1px solid #dee2e6;\n  margin-top: 4rem;\n  position: relative;\n  overflow: hidden;\n}\n\n.footer::before {\n  content: '';\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  height: 3px;\n  background: linear-gradient(90deg, #8B4513, #D2691E, #8B4513);\n}\n\n.footer-container {\n  max-width: 1400px;\n  margin: 0 auto;\n  padding: 0 2rem;\n  position: relative;\n  z-index: 1;\n}\n\n.footer-content {\n  display: grid;\n  grid-template-columns: 2fr 1fr 1fr 1fr;\n  gap: 3rem;\n  padding: 3rem 0 2rem 0;\n}\n\n.footer-section {\n  display: flex;\n  flex-direction: column;\n  gap: 1rem;\n}\n\n.footer-title {\n  font-size: 1.8rem;\n  font-weight: 700;\n  color: #2c3e50;\n  margin: 0;\n  background: linear-gradient(135deg, #8B4513, #D2691E);\n  -webkit-background-clip: text;\n  -webkit-text-fill-color: transparent;\n  background-clip: text;\n}\n\n.footer-subtitle {\n  font-size: 1.1rem;\n  color: #6c757d;\n  margin: 0;\n  font-weight: 600;\n}\n\n.footer-description {\n  font-size: 0.95rem;\n  color: #495057;\n  line-height: 1.6;\n  margin: 0;\n}\n\n.footer-section-title {\n  font-size: 1.2rem;\n  font-weight: 600;\n  color: #2c3e50;\n  margin: 0 0 1rem 0;\n  position: relative;\n}\n\n.footer-section-title::after {\n  content: '';\n  position: absolute;\n  bottom: -5px;\n  left: 0;\n  width: 30px;\n  height: 2px;\n  background: linear-gradient(90deg, #8B4513, #D2691E);\n  border-radius: 1px;\n}\n\n.footer-links {\n  list-style: none;\n  padding: 0;\n  margin: 0;\n  display: flex;\n  flex-direction: column;\n  gap: 0.8rem;\n}\n\n.footer-link {\n  color: #6c757d;\n  text-decoration: none;\n  font-size: 0.95rem;\n  transition: all 0.3s ease;\n  cursor: pointer;\n  background: none;\n  border: none;\n  padding: 0.5rem 0;\n  text-align: left;\n  width: 100%;\n  position: relative;\n  font-weight: 500;\n}\n\n.footer-link:hover {\n  color: #8B4513;\n  transform: translateX(8px);\n}\n\n.footer-link::before {\n  content: '';\n  position: absolute;\n  left: -15px;\n  top: 50%;\n  transform: translateY(-50%);\n  width: 0;\n  height: 2px;\n  background: linear-gradient(90deg, #8B4513, #D2691E);\n  transition: width 0.3s ease;\n}\n\n.footer-link:hover::before {\n  width: 10px;\n}\n\n.footer-tech {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 0.6rem;\n}\n\n.tech-tag {\n  background: linear-gradient(135deg, #8B4513, #D2691E);\n  color: white;\n  padding: 0.4rem 1rem;\n  border-radius: 20px;\n  font-size: 0.85rem;\n  font-weight: 600;\n  border: none;\n  transition: all 0.3s ease;\n  box-shadow: 0 2px 8px rgba(139, 69, 19, 0.2);\n}\n\n.tech-tag:hover {\n  transform: translateY(-2px);\n  box-shadow: 0 4px 12px rgba(139, 69, 19, 0.3);\n}\n\n.footer-contact {\n  display: flex;\n  flex-direction: column;\n  gap: 1rem;\n}\n\n.contact-item {\n  display: flex;\n  align-items: center;\n  gap: 1rem;\n  cursor: pointer;\n  padding: 0.8rem;\n  border-radius: 12px;\n  transition: all 0.3s ease;\n  background: rgba(255, 255, 255, 0.5);\n  border: 1px solid rgba(139, 69, 19, 0.1);\n}\n\n.contact-item:hover {\n  background: rgba(139, 69, 19, 0.05);\n  transform: translateX(5px);\n  border-color: rgba(139, 69, 19, 0.2);\n}\n\n.contact-icon {\n  font-size: 1.3rem;\n  min-width: 1.8rem;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.contact-text {\n  color: #495057;\n  font-size: 0.95rem;\n  font-weight: 500;\n  transition: color 0.3s ease;\n}\n\n.contact-item:hover .contact-text {\n  color: #8B4513;\n}\n\n.footer-bottom {\n  border-top: 1px solid #dee2e6;\n  padding: 2rem 0;\n  background: rgba(255, 255, 255, 0.3);\n}\n\n.footer-bottom-content {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  flex-wrap: wrap;\n  gap: 1.5rem;\n}\n\n.footer-copyright {\n  color: #6c757d;\n  font-size: 0.9rem;\n  margin: 0;\n  font-weight: 500;\n}\n\n.footer-social {\n  display: flex;\n  gap: 1rem;\n}\n\n.social-btn {\n  width: 45px;\n  height: 45px;\n  border: none;\n  border-radius: 50%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  cursor: pointer;\n  transition: all 0.3s ease;\n  background: white;\n  border: 2px solid #e9ecef;\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);\n}\n\n.social-btn:hover {\n  transform: translateY(-3px);\n  box-shadow: 0 6px 20px rgba(0, 0, 0, 0.15);\n}\n\n.github-btn {\n  color: #6c757d;\n}\n\n.github-btn:hover {\n  background: #333;\n  color: white;\n  border-color: #333;\n}\n\n.linkedin-btn {\n  color: #6c757d;\n}\n\n.linkedin-btn:hover {\n  background: #0077b5;\n  color: white;\n  border-color: #0077b5;\n}\n\n.email-btn {\n  color: #6c757d;\n}\n\n.email-btn:hover {\n  background: #ea4335;\n  color: white;\n  border-color: #ea4335;\n}\n\n/* Dark theme support */\n[data-theme=\"dark\"] .footer {\n  background: linear-gradient(135deg, #1a1a1a 0%, #2d2d2d 100%);\n  border-color: #404040;\n}\n\n[data-theme=\"dark\"] .footer::before {\n  background: linear-gradient(90deg, #D2691E, #CD853F, #D2691E);\n}\n\n[data-theme=\"dark\"] .footer-title {\n  background: linear-gradient(135deg, #D2691E, #CD853F);\n  -webkit-background-clip: text;\n  -webkit-text-fill-color: transparent;\n  background-clip: text;\n}\n\n[data-theme=\"dark\"] .footer-subtitle {\n  color: #b0b0b0;\n}\n\n[data-theme=\"dark\"] .footer-description {\n  color: #d0d0d0;\n}\n\n[data-theme=\"dark\"] .footer-section-title {\n  color: #f0f0f0;\n}\n\n[data-theme=\"dark\"] .footer-section-title::after {\n  background: linear-gradient(90deg, #D2691E, #CD853F);\n}\n\n[data-theme=\"dark\"] .footer-link {\n  color: #b0b0b0;\n}\n\n[data-theme=\"dark\"] .footer-link:hover {\n  color: #D2691E;\n}\n\n[data-theme=\"dark\"] .footer-link::before {\n  background: linear-gradient(90deg, #D2691E, #CD853F);\n}\n\n[data-theme=\"dark\"] .tech-tag {\n  background: linear-gradient(135deg, #D2691E, #CD853F);\n  box-shadow: 0 2px 8px rgba(210, 105, 30, 0.3);\n}\n\n[data-theme=\"dark\"] .tech-tag:hover {\n  box-shadow: 0 4px 12px rgba(210, 105, 30, 0.4);\n}\n\n[data-theme=\"dark\"] .contact-item {\n  background: rgba(255, 255, 255, 0.05);\n  border-color: rgba(210, 105, 30, 0.2);\n}\n\n[data-theme=\"dark\"] .contact-item:hover {\n  background: rgba(210, 105, 30, 0.1);\n  border-color: rgba(210, 105, 30, 0.3);\n}\n\n[data-theme=\"dark\"] .contact-text {\n  color: #d0d0d0;\n}\n\n[data-theme=\"dark\"] .contact-item:hover .contact-text {\n  color: #D2691E;\n}\n\n[data-theme=\"dark\"] .footer-bottom {\n  background: rgba(0, 0, 0, 0.2);\n  border-color: #404040;\n}\n\n[data-theme=\"dark\"] .footer-copyright {\n  color: #b0b0b0;\n}\n\n[data-theme=\"dark\"] .social-btn {\n  background: #2d2d2d;\n  border-color: #404040;\n  color: #b0b0b0;\n}\n\n[data-theme=\"dark\"] .social-btn:hover {\n  box-shadow: 0 6px 20px rgba(0, 0, 0, 0.3);\n}\n\n/* Responsive Design */\n@media (max-width: 1200px) {\n  .footer-container {\n    padding: 0 1.5rem;\n  }\n  \n  .footer-content {\n    gap: 2.5rem;\n  }\n}\n\n@media (max-width: 768px) {\n  .footer-content {\n    grid-template-columns: 1fr;\n    gap: 2rem;\n    padding: 2rem 0 1.5rem 0;\n  }\n  \n  .footer-container {\n    padding: 0 1rem;\n  }\n  \n  .footer-bottom-content {\n    flex-direction: column;\n    text-align: center;\n    gap: 1.5rem;\n  }\n  \n  .footer-social {\n    justify-content: center;\n  }\n  \n  .footer-title {\n    font-size: 1.6rem;\n  }\n}\n\n@media (max-width: 480px) {\n  .footer-container {\n    padding: 0 0.5rem;\n  }\n  \n  .footer-content {\n    padding: 1.5rem 0 1rem 0;\n  }\n  \n  .footer-title {\n    font-size: 1.4rem;\n  }\n  \n  .footer-description {\n    font-size: 0.9rem;\n  }\n  \n  .tech-tag {\n    font-size: 0.8rem;\n    padding: 0.3rem 0.8rem;\n  }\n  \n  .social-btn {\n    width: 40px;\n    height: 40px;\n  }\n  \n  .contact-item {\n    padding: 0.6rem;\n  }\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
